<template>
  <nav>
    <div class="container navigation navigation--top">
      <template v-if="isNotificationRoute">
        <h4 class="nav-title primary">{{ $t("Notifiche da leggere") }}</h4>
        <router-link class="close" to="/dashboard"></router-link>
      </template>
      <template v-else>
        <Logo />
        <router-link
          to="/dashboard/notifications"
          class="notification"
          v-bind:class="{ fill: $store.getters.getNotifications.length }"
          v-html="iconNotification"
        ></router-link>
        <LocaleChanger
          v-if="this.$store.state.campaign.accept_languages.length > 1"
        ></LocaleChanger>
      </template>
    </div>
    <div class="navigation navigation--bottom">
      <div class="container">
        <div class="row">
          <div class="col">
            <router-link to="/dashboard" class="navigation__link">
              <div class="navigation__icon" v-html="iconHome"></div>
              <h6
                class="navigation__name"
                v-bind:class="{ primary: $route.name === 'dashboard' }"
              >
                {{ $t("Home") }}
              </h6>
            </router-link>
          </div>
          <div class="col">
            <router-link to="/actions" class="navigation__link">
              <div class="navigation__icon" v-html="iconMission"></div>
              <h6
                class="navigation__name"
                v-bind:class="{ primary: $route.name === 'actions' }"
              >
                {{ $t("Missioni") }}
              </h6>
            </router-link>
          </div>
          <div class="col">
            <router-link to="/catalog" class="navigation__link">
              <div class="navigation__icon" v-html="iconAwards"></div>
              <h6
                class="navigation__name"
                v-bind:class="{ primary: $route.name === 'catalog' }"
              >
                {{ $t("Catalogo") }}
              </h6>
            </router-link>
          </div>
          <div class="col">
            <router-link to="/leaderboard" class="navigation__link">
              <div class="navigation__icon" v-html="iconClassification"></div>
              <h6
                class="navigation__name"
                v-bind:class="{ primary: $route.name === 'leaderboard' }"
              >
                {{ $t("Classifica") }}
              </h6>
            </router-link>
          </div>
          <div class="col">
            <router-link to="/settings/profile" class="navigation__link">
              <div class="navigation__icon" v-html="iconProfile"></div>
              <h6
                class="navigation__name"
                v-bind:class="{ primary: $route.name === '/settings/profile' }"
              >
                {{ $t("Profilo") }}
              </h6>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import Logo from "./Logo";
import iconNotification from "@/assets/svg/new/notification.svg";
import iconHome from "@/assets/svg/new/home-nav.svg";
import iconMission from "@/assets/svg/new/mission-nav.svg";
import iconAwards from "@/assets/svg/new/awards-nav.svg";
import iconClassification from "@/assets/svg/new/classification-nav.svg";
import iconProfile from "@/assets/svg/new/profile-nav.svg";
import LocaleChanger from "@/components/rebuild/common/LocaleChanger";

export default {
  name: "NavigationMobile",
  components: {
    Logo,
    LocaleChanger
  },
  data() {
    return {
      iconNotification,
      iconHome,
      iconMission,
      iconAwards,
      iconClassification,
      iconProfile,
      isNotificationRoute: false
    };
  },

  created() {
    console.log(this.$route);
    this.isNotificationRoute = this.$route.path.includes("notifications");
  },
  watch: {
    $route(to, from) {
      this.isNotificationRoute = to.path.includes("notifications");
    }
  }
};
</script>

<style lang="scss" scoped>
h4 {
  margin-bottom: 0;
}
nav {
  background-color: #fff;
  min-height: 75px;
  display: flex;
  align-items: center;
}
.navigation {
  display: flex;
  justify-content: space-between;
  width: 100%;
  background-color: #fff;
  align-items: center;
}

.navigation--top {
  padding-bottom: 0;
}

.navigation--bottom {
  position: fixed;
  bottom: 0;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
  box-shadow: 0 -1.5px 7.5px 0 rgba(156, 156, 156, 0.25);
  padding: 0;
  z-index: 100;
  background-color: #fff;
  .container {
    padding: 0;
  }
  @media (min-width: 465px) {
    padding: 0 15px;
    .container {
      padding: 0 15px;
    }
  }
}
.row {
  width: 100%;
  justify-content: space-between;
  margin: 0;
}

.col {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px 0;
  @media (min-width: 399px) {
    padding: 15px;
  }
}
.navigation__link {
  display: block;
  color: #000;
}
.navigation__icon {
  display: flex;
  justify-content: center;
  margin-bottom: 5px;
}
.navigation__name {
  font-size: 14px;
}

.router-link-active {
  ::v-deep path {
    // fill: #6120e6;
  }
}

.fill {
  ::v-deep path {
    fill: #ff0000;
  }
}
.close {
  position: relative;
  width: 32px;
  height: 32px;
  opacity: 1;
}
.close:before,
.close:after {
  position: absolute;
  left: 15px;
  content: " ";
  height: 33px;
  width: 2px;
  background-color: #000;
}
.close:before {
  transform: rotate(45deg);
}
.close:after {
  transform: rotate(-45deg);
}
</style>
